module.exports = __webpack_public_path__ + "img/courseM.f96fa90f.png";